/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

type PurchaserQuestionnaireQuestionHeaderProps = {
  eventName?: string;
  metadata?: React.ReactNode;
  questionLabel: string;
  text: string;
};

export const PurchaserQuestionnaireQuestionHeader: React.FC<
  PurchaserQuestionnaireQuestionHeaderProps
> = ({ eventName, metadata, questionLabel, text }) => (
  <header css={styles.header}>
    <span css={styles.questionLabel}>{questionLabel}</span>
    <div css={styles.questionDetails}>
      <h4 css={styles.questionText}>{text}</h4>
      {eventName ? (
        <p css={styles.eventName}>対象イベント: {eventName}</p>
      ) : null}
      {metadata ? <div css={styles.metadata}>{metadata}</div> : null}
    </div>
  </header>
);

const styles = {
  header: css`
    display: flex;
    align-items: flex-start;
    gap: 10px;
  `,
  questionLabel: css`
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 22px;
    padding: 0 8px;
    color: #00c2ae;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.5px;
    line-height: 1;
    background: rgb(0 194 174 / 15%);
    border-radius: 6px;
  `,
  questionDetails: css`
    min-width: 0;
  `,
  questionText: css`
    margin: 0;
    color: #ffffff;
    font-size: 13.5px;
    font-weight: 700;
    line-height: 1.5;
    overflow-wrap: anywhere;
  `,
  eventName: css`
    margin: 4px 0 0;
    color: #b9c3cd;
    font-size: 11.5px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  `,
  metadata: css`
    margin-top: 4px;
    color: #8b96a2;
    font-size: 12px;
    line-height: 1.5;
  `,
};
